import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

const breadcrumbStatic = [{
	name: 'Customer Feedback',
	url: '/admins/feedback_responses',
	icon: 'comment'
}];

export default class Feedback_Responses extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}/>
				<Collections.FeedbackResponses history={this.props.history}/>
			</div>
		)
	}
}
